/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AnlaegDto as OkEgisServiceModelsDtoAnlaegDto } from '../models/OK/Egis/Service/Models/DTO/anlaeg-dto';
import { AnlaegUpdateDto as OkEgisServiceModelsDtoAnlaegUpdateDto } from '../models/OK/Egis/Service/Models/DTO/anlaeg-update-dto';

@Injectable({
  providedIn: 'root',
})
export class AnlaegService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation updateAnlaeg
   */
  static readonly UpdateAnlaegPath = '/api/v1/Anlaeg/UpdateAnlaeg';

  /**
   * Updates a single Anlaeg.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAnlaeg()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAnlaeg$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoAnlaegUpdateDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoAnlaegDto>> {

    const rb = new RequestBuilder(this.rootUrl, AnlaegService.UpdateAnlaegPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoAnlaegDto>;
      })
    );
  }

  /**
   * Updates a single Anlaeg.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAnlaeg$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAnlaeg(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoAnlaegUpdateDto
  }): Observable<OkEgisServiceModelsDtoAnlaegDto> {

    return this.updateAnlaeg$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoAnlaegDto>) => r.body as OkEgisServiceModelsDtoAnlaegDto)
    );
  }

}
